<template>
  <v-list dense nav>
    <!-- Navigation Single Item -->
    <template v-for="item in drawerItems">
      <v-list-item
        v-if="!item.hasOwnProperty('children') && showSidebarItem(item)"
        :key="item.title"
        :to="item.to"
        link
        class="text-left"
        active-class="active-nav-item white--text"
      >
        <v-list-item-icon>
          <v-icon size="20">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- ENDS: Navigation Single Item -->
      <!-- ENDS: Navigation for Groups -->
      <template v-else>
        <v-list-group
          v-if="childrenHasPermission(item)"
          :key="item.title"
          v-model="item.active"
          class="text-left"
          active-class="white--text"
        >
          <v-icon slot="prependIcon" size="20" v-text="item.icon"></v-icon>
          <template v-slot:activator>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </template>
          <template v-for="(children, index) in item.children">
            <v-list-item
              v-if="showSidebarItem(children)"
              :key="index"
              :to="children.to"
              link
              class="ml-2"
              active-class="active-nav-item white--text"
            >
              <v-list-item-icon class="ml-6">
                <v-icon size="20" v-text="children.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ children.title }}</v-list-item-title>
              </v-list-item-content>
              <!-- TODO: counts for task, keep here. -->
            </v-list-item>
          </template>
        </v-list-group>
      </template>
      <!-- ENDS: Navigation for Groups -->
    </template>
  </v-list>
</template>
<script>
export default {
  props: {
    drawerItems: {
      type: Array,
      required: true
    }
  },
  methods: {
    showSidebarItem(item) {
      if (
        typeof this.$rhrCoreShellOptions.permissionGetterName === "undefined"
      ) {
        return true;
      } else {
        return this.$store.getters[
          this.$rhrCoreShellOptions.permissionGetterName
        ](this.$router.resolve(item.to).route);
      }
    },
    childrenHasPermission(item) {
      for (let child of item.children) {
        if (this.showSidebarItem(child)) return true;
      }
      return false;
    }
  }
};
</script>
<style>
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 12px !important;
}
</style>
